import React, { useState, useEffect } from "react";

import { useNavigate } from "react-router-dom";
import ToastModal from "../../components/ToastModal/ToastModal";

import {
  Container,
  Panel,
  Header,
  Title,
  Ornament,
  OrnLine,
  OrnDiamond,
  Subtitle,
  Form,
  Field,
  Label,
  Input,
  SubmitButton,
  Note,
  Message,
  CloseButton,
} from "./ChangePasswordPageStyles";

export default function ChangePasswordPage() {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [toastMessage, setToastMessage] = useState("");
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage("");
    setError("");

    try {
      const response = await fetch(process.env.REACT_APP_GRAPHQL_URL, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          query: `
            mutation requestResetPassword($email: String!) {
              requestResetPassword(email: $email) {
                message
              }
            }
          `,
          variables: { email },
        }),
      });

      const result = await response.json();

      if (result.errors) {
        setError(result.errors[0].message || "Eroare necunoscută.");
      } else {
        setToastMessage(
          "Verifică-ți e-mailul. Ți-am trimis un link de resetare.",
        );
      }
    } catch (err) {
      setError("Eroare de rețea sau server.");
    }
  };

  return (
    <Container>
      <CloseButton
        aria-label="Închide"
        onClick={() => navigate("/login", { state: { scrollTo: "top" } })}
      >
        ×
      </CloseButton>

      <Panel>
        <Header>
          <Title>Ai uitat parola?</Title>
          <Ornament aria-hidden="true">
            <OrnLine />
            <OrnDiamond />
          </Ornament>
          <Subtitle>
            Completează mai jos adresa de e-mail și îți trimitem un link ca să
            îți alegi o parolă nouă.
          </Subtitle>
        </Header>

        <Form onSubmit={handleSubmit}>
          <Field>
            <Label>E-mail *</Label>
            <Input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              autoComplete="email"
            />
          </Field>

          <SubmitButton type="submit">Trimite link</SubmitButton>

          {message && <Message success>{message}</Message>}
          {error && <Message>{error}</Message>}

          <Note>Toate câmpurile marcate cu * trebuie completate.</Note>
        </Form>
      </Panel>

      {toastMessage && (
        <ToastModal
          message={toastMessage}
          onClose={() => {
            setToastMessage("");
            navigate("/login", { state: { scrollTo: "top" } });
          }}
        />
      )}
    </Container>
  );
}
